<template>
  <div class="entry_index mb-4">
    <div class="d-flex align-items-center">
      <div class="step_item" :class="{ 'list-group-item-primary': step == 1 }">送付先情報入力</div>
      <i class="fas fa-chevron-right"></i>
      <div class="step_item" :class="{ 'list-group-item-primary': step == 4 }">登録内容の確認</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.step_item {
  margin: 0 0.4em;
  @media screen and (max-width:767px) {
    font-size: 0.8em;
  }
}
</style>

<script>
export default {
  name: 'EntryIndex',
  props: {
    step: Number
  }
}
</script>
